import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';

export default class IdeasTableCellThemesComponent extends DropdownActivator {
  @service store;
  @tracked themeFormIsVisible = false;
  selectedIdea = null;

  get idea() {
    return this.args.idea;
  }

  @action
  handleThemesChange(idea, e) {
    const themes = e.map((id) => this.store.peekRecord('theme', id));
    idea.themes = themes;
    idea.save();
  }

  @action
  toggleThemeForm(idea, val) {
    if (idea) this.selectedIdea = idea;
    else this.selectedIdea = null;
    if (val !== undefined) this.themeFormIsVisible = val;
    else this.themeFormIsVisible = !this.themeFormIsVisible;
  }

  @action
  async onThemeAdded(theme) {
    const themes = [...this.selectedIdea.themes.content];
    themes.push(theme);
    this.selectedIdea.themes = themes;
    await this.selectedIdea.save();
  }

  get themesList() {
    const themes = this.store.peekAll('theme').map((item) => ({
      value: item.id,
      label: item.title,
    }));
    return themes;
  }

  get sortedThemes() {
    return this.idea.themes?.content?.toSorted((a, b) =>
      nameSort(a.title, b.title, 'asc'),
    );
  }

  get firstTheme() {
    return this.sortedThemes?.[0];
  }

  willDestroy() {
    this.themeFormIsVisible = false;
    this.selectedIdea = null;
    super.willDestroy(...arguments);
  }
}
